import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_ObjectType_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectType/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_ObjectType_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectType/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_ObjectType_Api = async (id) => {
    const { data } = await request.get(
        `/ObjectType/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_ObjectType_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectType/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_ObjectType_Api = async (id) => {
    const { data } = await request.delete(
        `/ObjectType/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
